import moment from 'moment';
import { DEFAULT_ESTIMATES_COUNT, ReclamationStatus } from '../models';

export const fallbackEmailTemplates = [
  {
    key: 'EmailCustomerClaimMessage',
    name: 'Email Customer Claim Message',
  },
  {
    key: 'EmailClaimInvestigating',
    name: 'Email Claim Investigating',
  },
  {
    key: 'EmailClaimRepairApproval',
    name: 'Email Claim Repair Approval',
  },
  {
    key: 'EmailClaimDesignatedRepairShop',
    name: 'Email Claim Preferred Body Shop',
  },
  {
    key: 'EmailClaimFinalApproval',
    name: 'Email Claim Final Approval',
  },
  {
    key: 'EmailClaimDenied',
    name: 'Email Claim Denied',
  },
  {
    key: 'EmailClaimCompleted',
    name: 'Claim Completed',
  },
];

export const fallbackEmailTemplateBodies = {
  EmailCustomerClaimMessage: `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="color-scheme" content="light">
    <title>Damage Claim Confirmation</title>
    <style type="text/css">
        @media only screen and (max-width: 600px) {
            .info-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box !important;
            }

            .info-spacer {
                display: block !important;
                width: 100% !important;
                height: 16px !important;
                font-size: 0 !important;
                line-height: 0 !important;
            }

            .info-table {
                width: 100% !important;
            }
        }
    </style>
</head>

<body style="margin:0;padding:0;background-color:#f4f4f4;font-family:Arial,Helvetica,sans-serif;color:#222222;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f4f4f4;">
        <tbody>
            <tr>
                <td align="center" style="padding: 24px 12px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width: 650px; background-color: #ffffff;">
                        <tbody>
                            <tr>
                                <td class="email-content" style="padding: 32px 28px; font-size: 16px; line-height: 1.6;">
                                    <p style="margin: 0 0 20px;">Hello {{customerName}},</p>
                                    <p style="margin: 0 0 20px;">This email is to confirm that a claim has been opened on your behalf and is pending review. <strong>Please reply to this email</strong> after reviewing the information to confirm that you are ready to proceed with next steps. Please find the details of the claim below.</p>
                                    <!-- Claim Information -->
                                    <!-- Responsive Claim and Vehicle Information -->
                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse; margin: 0 0 32px;">
                                        <tbody>
                                            <tr>
                                                <!-- Claim Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Claim Number: {{claimId}}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 10px;"><strong>Date &amp; Time of Incident:</strong>{{issuedAt}}</p>
                                                                    <p style="margin: 0 0 10px;"><strong>Location: </strong>{{siteName}}</p>
                                                                    <p style="margin: 0;"><strong>Status: {{status}}</strong></p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <!-- Column Spacer -->
                                                <td class="info-spacer" width="4%" style="width: 4%; font-size: 0; line-height: 0;">&nbsp;</td>
                                                <!-- Vehicle Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Vehicle Information</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 6px;"><strong>Year:</strong> {{year}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Make:</strong> {{make}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Model:</strong> {{model}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>VIN:</strong> {{vin}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Color:</strong> {{color}}</p>
                                                                    <p style="margin: 0;"><strong>License Plate #:</strong> {{plate}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p style="margin: 0 0 20px;">Our team will evaluate the information provided and follow up with you regarding next steps within the next 3 business days. Here is what you can expect to happen during this process:</p>
                                    <p style="margin: 0 0 12px;">Please know that we may require one or all of the items below before a decision is made:</p>
                                    <ul style="margin: 0 0 24px; padding-left: 24px;">
                                        <li style="margin-bottom: 6px;">A return visit to the wash site, if necessary</li>
                                        <li style="margin-bottom: 6px;">Discussions with team members who witnessed the incident</li>
                                        <li style="margin-bottom: 6px;">Review of all available evidence</li>
                                        <li style="margin-bottom: 6px;">Collection of any additional supporting documentation</li>
                                    </ul>
                                    <p style="margin: 0 0 20px;">To ensure a complete and accurate investigation, we encourage you to review your recent vehicle activity and consider whether the damage could have occurred elsewhere. Please think about recent travel, parking situations, road conditions, or other events that could have contributed to the damage.</p>
                                    <p style="margin: 0 0 20px;">After completing our initial review, we will move to the investigation of the claim. During this stage, we will thoroughly review all information gathered during the initial claim review, including photos, statements, vehicle information, and any other relevant details. We will also discuss the incident with our leadership team to determine whether the damage could have been caused by our wash site. Once the investigation is complete, a determination will be made to move to the next steps, either to approve or deny the claim.</p>
                                    <p style="margin: 0 0 20px;">If the claim is approved, you may be asked to visit a pre-selected repair facility or obtain up to three repair estimates. We will review the estimates and determine the appropriate repair option before moving to the final approval stage, where the repair costs and repair facility will be formally approved. Please note that payment for approved repairs will only be issued directly to the repair facility after verification that all repairs have been completed.</p>
                                    <p style="margin: 0 0 20px;">To help us move forward with the next step in the process, <strong>please reply to this email</strong> confirming that you accept the process outlined above. Once we receive your confirmation, we will proceed accordingly.</p>
                                    <p style="margin: 0 0 28px;">Thank you for your patience while we complete this process.<br><br>{{attachmentsSectionHtml}}</p>
                                    <p style="margin: 0;">Sincerely,<br><strong>Tommy's Express Car Wash</strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</body>

</html>`,
  EmailClaimInvestigating: `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Claim Investigation Update</title>

    <style type="text/css">
        @media only screen and (max-width: 600px) {
            .info-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box !important;
            }

            .info-spacer {
                display: block !important;
                width: 100% !important;
                height: 16px !important;
                font-size: 0 !important;
                line-height: 0 !important;
            }

            .info-table {
                width: 100% !important;
            }

            .email-content {
                padding: 24px 16px !important;
            }
        }
    </style>
</head>

<body style="margin:0;padding:0;background-color:#f4f4f4;font-family:Arial,Helvetica,sans-serif;color:#222222;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f4f4f4;">
        <tbody>
            <tr>
                <td align="center" style="padding: 24px 12px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width: 650px; background-color: #ffffff;">
                        <tbody>
                            <tr>
                                <td class="email-content" style="padding: 32px 28px; font-size: 16px; line-height: 1.6;">
                                    <p style="margin: 0 0 24px;">Hello {{customerName}},</p>
                                    <!-- Responsive Claim and Vehicle Information -->
                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse; margin: 0 0 32px;">
                                        <tbody>
                                            <tr>
                                                <!-- Claim Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Claim Number: {{claimId}}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 10px;"><strong>Date &amp; Time of Incident:</strong><br>{{issuedAt}}</p>
                                                                    <p style="margin: 0 0 10px;"><strong>Location: </strong>{{siteName}}</p>
                                                                    <p style="margin: 0;"><strong>Status: </strong>{{status}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <!-- Spacer Between Columns -->
                                                <td class="info-spacer" width="4%" style="width: 4%; font-size: 0; line-height: 0;">&nbsp;</td>
                                                <!-- Vehicle Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Vehicle Information</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 6px;"><strong>Year:</strong> {{year}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Make:</strong> {{make}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Model:</strong> {{model}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>VIN:</strong> {{vin}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Color:</strong> {{color}}</p>
                                                                    <p style="margin: 0;"><strong>License Plate #:</strong> {{plate}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Investigation Update -->
                                    <p style="margin: 0 0 20px;"><strong>Your claim is under investigation.</strong></p>
                                    <p style="margin: 0 0 20px;">Our team is currently reviewing all the details related to the incident.</p>
                                    <p style="margin: 0 0 20px;">We expect to complete our review and provide you with a final decision within the next few days. We will contact you as soon as the investigation is complete.</p>
                                    <p style="margin: 0 0 32px;">Thank you for your patience while we complete this process.<br><br>{{attachmentsSectionHtml}}</p>
                                    <p style="margin: 0;">Sincerely,<br><strong>Tommy's Express Car Wash</strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</body>

</html>`,
  EmailClaimResolved: `{{#> EmailLayout}}
<td class="content-wrap" style="font-family: Arial, Helvetica, sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0; padding: 32px;" valign="top">
    <table width="100%" cellpadding="0" cellspacing="0" style="border-collapse: collapse;">
        <tr><td style="padding: 0 0 20px;">Hello {{customerName}},</td></tr>
        <tr><td style="padding: 0;"><table width="100%" cellpadding="0" cellspacing="0" style="border: 1px solid #cccccc;"><tr><td style="width: 58%; vertical-align: top; padding: 24px; border-right: 1px solid #cccccc;"><strong>Claim Number:</strong> {{claimId}}<br><br>&bull; <strong>Date &amp; Time of Incident:</strong> {{issuedAt}}<br>&bull; <strong>Location:</strong> {{siteName}}<br>&bull; <strong>Status:</strong> Resolved</td><td style="width: 42%; vertical-align: top; padding: 24px;"><strong style="font-size: 20px;">Vehicle Information</strong><br><br>&bull; <strong>Year:</strong> {{year}}<br>&bull; <strong>Make:</strong> {{make}}<br>&bull; <strong>Model:</strong> {{model}}<br>&bull; <strong>VIN:</strong> {{vin}}<br>&bull; <strong>Color:</strong> {{color}}<br>&bull; <strong>License Plate #:</strong> {{plate}}</td></tr></table></td></tr>
        <tr><td style="padding: 28px 0 0;"><strong>Your claim has been resolved.</strong></td></tr>
        <tr><td style="padding: 0 0 20px;">Thank you for taking the time to discuss your claim with us.</td></tr>
        <tr><td style="padding: 20px 0;">As discussed, we have completed our review and resolved this matter by issuing a <strong>{{resolution}}</strong>. During our conversation, the proposed resolution was reviewed with you and accepted. This email serves as confirmation of the agreed-upon resolution and the closure of your claim.</td></tr>
        <tr><td style="padding: 20px 0;">For our records, please reply to this email confirming that you accept the resolution outlined above. Upon receipt of your confirmation, we will consider this matter fully resolved and closed.</td></tr>
        <tr><td style="padding: 20px 0;">Thank you for your cooperation throughout the review process. If you have any questions, please let us know.</td></tr>
        <tr><td style="padding: 20px 0 0;">Sincerely,<br>{{siteLeaderName}}</td></tr>
    </table>
</td>
{{/EmailLayout}}`,
  EmailClaimRepairApproval: `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Claim Awaiting Repair Estimates</title>

    <style type="text/css">
        @media only screen and (max-width: 600px) {
            .info-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box !important;
            }

            .info-spacer {
                display: block !important;
                width: 100% !important;
                height: 16px !important;
                font-size: 0 !important;
                line-height: 0 !important;
            }

            .info-table {
                width: 100% !important;
            }

            .email-content {
                padding: 24px 16px !important;
            }
        }
    </style>
</head>

<body style="margin:0;padding:0;background-color:#f4f4f4;font-family:Arial,Helvetica,sans-serif;color:#222222;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f4f4f4;">
        <tbody>
            <tr>
                <td align="center" style="padding: 24px 12px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width: 650px; background-color: #ffffff;">
                        <tbody>
                            <tr>
                                <td class="email-content" style="padding: 32px 28px; font-size: 16px; line-height: 1.6;">
                                    <p style="margin: 0 0 24px;">Hello {{customerName}},</p>
                                    <!-- Responsive Claim and Vehicle Information -->
                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse; margin: 0 0 32px;">
                                        <tbody>
                                            <tr>
                                                <!-- Claim Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Claim Number: {{claimId}}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 10px;"><strong>Date &amp; Time of Incident:</strong><br>{{issuedAt}}</p>
                                                                    <p style="margin: 0 0 10px;"><strong>Location: </strong>{{siteName}}</p>
                                                                    <p style="margin: 0;"><strong>Status: </strong>{{status}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <!-- Spacer Between Columns -->
                                                <td class="info-spacer" width="4%" style="width: 4%; font-size: 0; line-height: 0;">&nbsp;</td>
                                                <!-- Vehicle Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Vehicle Information</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 6px;"><strong>Year:</strong> {{year}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Make:</strong> {{make}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Model:</strong> {{model}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>VIN:</strong> {{vin}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Color:</strong> {{color}}</p>
                                                                    <p style="margin: 0;"><strong>License Plate #:</strong> {{plate}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Repair Estimates Notification -->
                                    <p style="margin: 0 0 20px;"><strong>Your claim is awaiting repair estimates.</strong></p>
                                    <p style="margin: 0 0 20px;">After completing our investigation of your vehicle claim, we have determined that the issue will be covered and have approved the necessary repairs.</p>
                                    <p style="margin: 0 0 20px;">Before repairs can begin, we will need {{estimatesCount}} estimate(s) from local repair shops submitted for review.</p>
                                    <p style="margin: 0 0 20px;">Once received and approved, you may proceed with scheduling the repair work. Please note that the selected repair shop will need to bill <strong>{{repairBillingName}}</strong> directly for payment.</p>
                                    <p style="margin: 0 0 20px;">For our records, please reply to this email confirming that you accept the resolution outlined above.</p>
                                    <p style="margin: 0 0 24px;">If you have any questions or need assistance with these steps, please feel free to contact us.<br><br>{{attachmentsSectionHtml}}</p>
                                    <p style="margin: 0;">Sincerely,<br><strong>Tommy's Express Car Wash</strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</body>

</html>`,
  EmailClaimDesignatedRepairShop: `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Claim Ready to Schedule Repairs</title>

    <style type="text/css">
        @media only screen and (max-width: 600px) {
            .info-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box !important;
            }

            .info-spacer {
                display: block !important;
                width: 100% !important;
                height: 16px !important;
                font-size: 0 !important;
                line-height: 0 !important;
            }

            .info-table {
                width: 100% !important;
            }

            .email-content {
                padding: 24px 16px !important;
            }
        }
    </style>
</head>

<body style="margin:0;padding:0;background-color:#f4f4f4;font-family:Arial,Helvetica,sans-serif;color:#222222;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f4f4f4;">
        <tbody>
            <tr>
                <td align="center" style="padding: 24px 12px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width: 650px; background-color: #ffffff;">
                        <tbody>
                            <tr>
                                <td class="email-content" style="padding: 32px 28px; font-size: 16px; line-height: 1.6;">
                                    <p style="margin: 0 0 24px;">Hello {{customerName}},</p>
                                    <!-- Responsive Claim and Vehicle Information -->
                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse; margin: 0 0 32px;">
                                        <tbody>
                                            <tr>
                                                <!-- Claim Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Claim Number: {{claimId}}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 10px;"><strong>Date &amp; Time of Incident:</strong><br>{{issuedAt}}</p>
                                                                    <p style="margin: 0 0 10px;"><strong>Location: </strong>{{siteName}}</p>
                                                                    <p style="margin: 0;"><strong>Status: </strong>{{status}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <!-- Spacer Between Columns -->
                                                <td class="info-spacer" width="4%" style="width: 4%; font-size: 0; line-height: 0;">&nbsp;</td>
                                                <!-- Vehicle Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Vehicle Information</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 6px;"><strong>Year:</strong> {{year}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Make:</strong> {{make}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Model:</strong> {{model}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>VIN:</strong> {{vin}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Color:</strong> {{color}}</p>
                                                                    <p style="margin: 0;"><strong>License Plate #:</strong> {{plate}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Ready to Schedule Repairs Notification -->
                                    <p style="margin: 0 0 20px;"><strong>Your claim is ready to schedule repairs.</strong></p>
                                    <p style="margin: 0 0 20px;">After completing our investigation of your claim, we have determined that the issue will be covered.</p>
                                    <p style="margin: 0 0 20px;">You may proceed with scheduling the repair at your convenience at <strong>{{repairShopName}}</strong> located at <strong>{{repairShopAddress}}</strong>.</p>
                                    <p style="margin: 0 0 20px;">We do not cover or reimburse any rental vehicle expenses during the repair period.</p>
                                    <p style="margin: 0 0 32px;">For our records, please reply to this email confirming that you accept the next steps outlined above.</p>
                                    <p style="margin: 0;">Sincerely,<br><strong>Tommy's Express Car Wash</strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</body>

</html>`,
  EmailClaimFinalApproval: `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Repair Estimate Approved</title>

    <style type="text/css">
        @media only screen and (max-width: 600px) {
            .info-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box !important;
            }

            .info-spacer {
                display: block !important;
                width: 100% !important;
                height: 16px !important;
                font-size: 0 !important;
                line-height: 0 !important;
            }

            .info-table {
                width: 100% !important;
            }

            .email-content {
                padding: 24px 16px !important;
            }
        }
    </style>
</head>

<body style="margin:0;padding:0;background-color:#f4f4f4;font-family:Arial,Helvetica,sans-serif;color:#222222;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f4f4f4;">
        <tbody>
            <tr>
                <td align="center" style="padding: 24px 12px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width: 650px; background-color: #ffffff;">
                        <tbody>
                            <tr>
                                <td class="email-content" style="padding: 32px 28px; font-size: 16px; line-height: 1.6;">
                                    <p style="margin: 0 0 24px;">Hello {{customerName}},</p>
                                    <!-- Responsive Claim and Vehicle Information -->
                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse; margin: 0 0 32px;">
                                        <tbody>
                                            <tr>
                                                <!-- Claim Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Claim Number: {{claimId}}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 10px;"><strong>Date &amp; Time of Incident:</strong><br>{{issuedAt}}</p>
                                                                    <p style="margin: 0 0 10px;"><strong>Location: </strong>{{siteName}}</p>
                                                                    <p style="margin: 0;"><strong>Status: </strong>{{status}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <!-- Spacer Between Columns -->
                                                <td class="info-spacer" width="4%" style="width: 4%; font-size: 0; line-height: 0;">&nbsp;</td>
                                                <!-- Vehicle Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Vehicle Information</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 6px;"><strong>Year:</strong> {{year}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Make:</strong> {{make}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Model:</strong> {{model}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>VIN:</strong> {{vin}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Color:</strong> {{color}}</p>
                                                                    <p style="margin: 0;"><strong>License Plate #:</strong> {{plate}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Repair Estimate Approval -->
                                    <p style="margin: 0 0 20px;"><strong>Your repair estimate has been approved.</strong></p>
                                    <p style="margin: 0 0 20px;">We have reviewed the repair estimate(s) provided and have approved the estimate from <strong>{{repairShopName}}</strong> for the following repairs: <strong>{{approvedRepairs}}</strong>.</p>
                                    <p style="margin: 0 0 20px;">The total approved cost is <strong>\${{approvedAmount}}</strong>, based on the attached itemized estimate, which reflects the full repair price.</p>
                                    <p style="margin: 0 0 20px;">You may proceed with scheduling the repair at your convenience. Please note that the repair shop must bill <strong>{{repairBillingName}}</strong> directly for payment. We do not cover or reimburse any rental vehicle expenses during the repair period.</p>
                                    <p style="margin: 0 0 24px;">For our records, please reply to this email confirming that you accept the resolution outlined above.<br><br>{{attachmentsSectionHtml}}</p>
                                    <p style="margin: 0;">Sincerely,<br><strong>Tommy's Express Car Wash</strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</body>

</html>`,
  EmailClaimDenied: `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Claim Decision Update</title>

    <style type="text/css">
        @media only screen and (max-width: 600px) {
            .info-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box !important;
            }

            .info-spacer {
                display: block !important;
                width: 100% !important;
                height: 16px !important;
                font-size: 0 !important;
                line-height: 0 !important;
            }

            .info-table {
                width: 100% !important;
            }

            .email-content {
                padding: 24px 16px !important;
            }
        }
    </style>
</head>

<body style="margin:0;padding:0;background-color:#f4f4f4;font-family:Arial,Helvetica,sans-serif;color:#222222;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f4f4f4;">
        <tbody>
            <tr>
                <td align="center" style="padding: 24px 12px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width: 650px; background-color: #ffffff;">
                        <tbody>
                            <tr>
                                <td class="email-content" style="padding: 32px 28px; font-size: 16px; line-height: 1.6;">
                                    <p style="margin: 0 0 24px;">Hello {{customerName}},</p>
                                    <!-- Responsive Claim and Vehicle Information -->
                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse; margin: 0 0 32px;">
                                        <tbody>
                                            <tr>
                                                <!-- Claim Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Claim Number: {{claimNumber}}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 10px;"><strong>Date &amp; Time of Incident:</strong><br>{{issuedAt}}</p>
                                                                    <p style="margin: 0 0 10px;"><strong>Location: </strong>{{siteName}}</p>
                                                                    <p style="margin: 0;"><strong>Status: </strong>{{status}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <!-- Spacer Between Columns -->
                                                <td class="info-spacer" width="4%" style="width: 4%; font-size: 0; line-height: 0;">&nbsp;</td>
                                                <!-- Vehicle Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Vehicle Information</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 6px;"><strong>Year:</strong> {{year}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Make:</strong> {{make}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Model:</strong> {{model}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>VIN:</strong> {{vin}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Color:</strong> {{color}}</p>
                                                                    <p style="margin: 0;"><strong>License Plate #:</strong> {{plate}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Claim Denial Notification -->
                                    <p style="margin: 0 0 20px;"><strong>Your claim has been denied.</strong></p>
                                    <p style="margin: 0 0 20px;">After completing a full investigation of the concern you reported regarding your vehicle, we have determined that the issue is not the result of the wash process at our facility.</p>
                                    <p style="margin: 0 0 20px;">Based on our review, we found no indication that our equipment or procedures contributed to the condition described.</p>
                                    <p style="margin: 0 0 20px;">As a result, we are unable to approve coverage for repairs to your vehicle. We understand this may be disappointing, and we appreciate the opportunity to review your claim.</p>
                                    <p style="margin: 0 0 32px;">For our records, please reply to this email confirming that you've received our decision.<br><br>{{attachmentsSectionHtml}}</p>
                                    <p style="margin: 0;">Sincerely,<br><strong>Tommy's Express Car Wash</strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</body>

</html>`,
  EmailClaimCompleted: `<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Claim Completed</title>

    <style type="text/css">
        @media only screen and (max-width: 600px) {
            .info-column {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                box-sizing: border-box !important;
            }

            .info-spacer {
                display: block !important;
                width: 100% !important;
                height: 16px !important;
                font-size: 0 !important;
                line-height: 0 !important;
            }

            .info-table {
                width: 100% !important;
            }

            .email-content {
                padding: 24px 16px !important;
            }
        }
    </style>
</head>

<body style="margin:0;padding:0;background-color:#f4f4f4;font-family:Arial,Helvetica,sans-serif;color:#222222;">
    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #f4f4f4;">
        <tbody>
            <tr>
                <td align="center" style="padding: 24px 12px;">
                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="max-width: 650px; background-color: #ffffff;">
                        <tbody>
                            <tr>
                                <td class="email-content" style="padding: 32px 28px; font-size: 16px; line-height: 1.6;">
                                    <p style="margin: 0 0 24px;">Hello {{customerName}},</p>
                                    <!-- Responsive Claim and Vehicle Information -->
                                    <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse; margin: 0 0 32px;">
                                        <tbody>
                                            <tr>
                                                <!-- Claim Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Claim Number: {{claimId}}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 10px;"><strong>Date &amp; Time of Incident:</strong><br>{{issuedAt}}</p>
                                                                    <p style="margin: 0 0 10px;"><strong>Location: </strong>{{siteName}}</p>
                                                                    <p style="margin: 0;"><strong>Status: </strong>{{status}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <!-- Spacer Between Columns -->
                                                <td class="info-spacer" width="4%" style="width: 4%; font-size: 0; line-height: 0;">&nbsp;</td>
                                                <!-- Vehicle Information -->
                                                <td class="info-column" width="48%" valign="top" style="width: 48%; vertical-align: top;">
                                                    <table class="info-table" role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 12px; background-color: #f7f7f7;"><strong>Vehicle Information</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #cccccc; padding: 16px;">
                                                                    <p style="margin: 0 0 6px;"><strong>Year:</strong> {{year}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Make:</strong> {{make}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Model:</strong> {{model}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>VIN:</strong> {{vin}}</p>
                                                                    <p style="margin: 0 0 6px;"><strong>Color:</strong> {{color}}</p>
                                                                    <p style="margin: 0;"><strong>License Plate #:</strong> {{plate}}</p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Claim Completed Notification -->
                                    <p style="margin: 0 0 20px;"><strong>Your claim has been completed.</strong></p>
                                    <p style="margin: 0 0 20px;">Your claim has been moved to a Completed status and is considered closed. We appreciate your patience and cooperation throughout this process. Our goal is always to provide a fair and timely resolution while delivering the best possible experience for our guests.</p>
                                    <p style="margin: 0 0 32px;">If you have any questions regarding this resolution or believe additional information should be reviewed, please contact us within 30 days of receiving this email.<br><br>{{attachmentsSectionHtml}}</p>
                                    <p style="margin: 0;">Sincerely,<br><strong>Tommy's Express Car Wash</strong></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</body>

</html>`,
};

const fallbackEmailTemplateSubjects = {
  EmailCustomerClaimMessage: 'Your claim request has been created.',
  EmailClaimInvestigating: 'Your claim is under investigation.',
  EmailClaimRepairApproval: 'Your next steps – estimates required.',
  EmailClaimDesignatedRepairShop: 'Your next steps – schedule repairs.',
  EmailClaimFinalApproval: 'Your claim estimate is approved.',
  EmailClaimDenied: 'Your claim has been denied.',
  EmailClaimCompleted: 'Your claim has been completed.',
};

const formatTemplateValue = (value) => {
  if (value === null || value === undefined) return '';
  return `${value}`;
};

export const getClaimEmailTemplateIdentifier = (template) =>
  template?.key || template?.type || template?.name || '';

const resolveTemplateConditionals = (template) =>
  template
    .replace(/{{#if\s+customBody}}([\s\S]*?){{else}}([\s\S]*?){{\/if}}/gi, '$2')
    .replace(/{{#if\s+customBody}}([\s\S]*?){{\/if}}/gi, '');

// Repair shops bill the operator group for the claim's site, e.g. "Tommy's Express - Holland".
export const getRepairBillingName = (operatorGroupName, siteName) =>
  [...new Set([operatorGroupName, siteName].map((name) => `${name || ''}`.trim()))]
    .filter(Boolean)
    .join(' - ');

export const renderEmailTemplateBody = (
  template,
  { isHtml = false, reclamation, venue, operatorGroup, templateFields = {} } = {}
) => {
  if (!template) return '';

  const vehicleDetails = reclamation?.vehicleDetails || {};
  const incidentDateSource = reclamation?.issueDate || reclamation?.createdAt;
  const issueDate = incidentDateSource
    ? moment(incidentDateSource).format('MM/DD/YYYY hh:mm A')
    : '';
  const issueDateOnly = incidentDateSource ? moment(incidentDateSource).format('MM/DD/YYYY') : '';
  const issueTimeOnly = incidentDateSource ? moment(incidentDateSource).format('hh:mm A') : '';
  const statusLabel =
    Object.keys(ReclamationStatus).find((key) => ReclamationStatus[key] === reclamation?.status) ||
    '';
  const estimatesCount = templateFields.estimatesCount || DEFAULT_ESTIMATES_COUNT;
  const repairBillingName = getRepairBillingName(
    operatorGroup?.name,
    venue?.name || reclamation?.issueSite?.name
  );
  const replacements = {
    '{{id}}': formatTemplateValue(reclamation?.id),
    '{{claimId}}': formatTemplateValue(reclamation?.id),
    '{{claimNumber}}': formatTemplateValue(reclamation?.id),
    '{{issueNumber}}': formatTemplateValue(reclamation?.id),
    '{{messageBody.id}}': formatTemplateValue(reclamation?.id),
    '{{messageBody.claimId}}': formatTemplateValue(reclamation?.id),
    '{{messageBody.claimNumber}}': formatTemplateValue(reclamation?.id),
    '{{messageBody.issueNumber}}': formatTemplateValue(reclamation?.id),
    '{{customerName}}': formatTemplateValue(reclamation?.customerName),
    '{{messageBody.customerName}}': formatTemplateValue(reclamation?.customerName),
    '{{customerEmail}}': formatTemplateValue(reclamation?.customerEmail),
    '{{messageBody.customerEmail}}': formatTemplateValue(reclamation?.customerEmail),
    '{{customerPhone}}': formatTemplateValue(reclamation?.customerPhone),
    '{{messageBody.customerPhone}}': formatTemplateValue(reclamation?.customerPhone),
    '{{make}}': formatTemplateValue(vehicleDetails.make),
    '{{messageBody.make}}': formatTemplateValue(vehicleDetails.make),
    '{{model}}': formatTemplateValue(vehicleDetails.model),
    '{{messageBody.model}}': formatTemplateValue(vehicleDetails.model),
    '{{year}}': formatTemplateValue(vehicleDetails.year),
    '{{messageBody.year}}': formatTemplateValue(vehicleDetails.year),
    '{{color}}': formatTemplateValue(vehicleDetails.color),
    '{{messageBody.color}}': formatTemplateValue(vehicleDetails.color),
    '{{vin}}': formatTemplateValue(vehicleDetails.vin),
    '{{messageBody.vin}}': formatTemplateValue(vehicleDetails.vin),
    '{{plate}}': formatTemplateValue(vehicleDetails.plate),
    '{{messageBody.plate}}': formatTemplateValue(vehicleDetails.plate),
    '{{status}}': formatTemplateValue(statusLabel),
    '{{messageBody.status}}': formatTemplateValue(statusLabel),
    '{{issueDate}}': formatTemplateValue(issueDate),
    '{{issuedAt}}': formatTemplateValue(issueDate),
    '{{incidentDate}}': formatTemplateValue(issueDate),
    '{{dateAndTime}}': formatTemplateValue(issueDate),
    '{{dateTime}}': formatTemplateValue(issueDate),
    '{{dateOfIncident}}': formatTemplateValue(issueDate),
    '{{dateTimeOfIncident}}': formatTemplateValue(issueDate),
    '{{date}}': formatTemplateValue(issueDateOnly),
    '{{time}}': formatTemplateValue(issueTimeOnly),
    '{{incidentTime}}': formatTemplateValue(issueTimeOnly),
    '{{timeOfIncident}}': formatTemplateValue(issueTimeOnly),
    '{{messageBody.issueDate}}': formatTemplateValue(issueDate),
    '{{messageBody.issuedAt}}': formatTemplateValue(issueDate),
    '{{messageBody.incidentDate}}': formatTemplateValue(issueDate),
    '{{messageBody.dateAndTime}}': formatTemplateValue(issueDate),
    '{{messageBody.dateTime}}': formatTemplateValue(issueDate),
    '{{messageBody.dateOfIncident}}': formatTemplateValue(issueDate),
    '{{messageBody.dateTimeOfIncident}}': formatTemplateValue(issueDate),
    '{{messageBody.date}}': formatTemplateValue(issueDateOnly),
    '{{messageBody.time}}': formatTemplateValue(issueTimeOnly),
    '{{messageBody.incidentTime}}': formatTemplateValue(issueTimeOnly),
    '{{messageBody.timeOfIncident}}': formatTemplateValue(issueTimeOnly),
    '{{siteName}}': formatTemplateValue(venue?.name || reclamation?.issueSite?.name),
    '{{messageBody.siteName}}': formatTemplateValue(venue?.name || reclamation?.issueSite?.name),
    '{{location}}': formatTemplateValue(venue?.name || reclamation?.issueSite?.name),
    '{{messageBody.location}}': formatTemplateValue(venue?.name || reclamation?.issueSite?.name),
    '{{venueName}}': formatTemplateValue(venue?.name || reclamation?.issueSite?.name),
    '{{venue.name}}': formatTemplateValue(venue?.name || reclamation?.issueSite?.name),
    '{{siteLeaderName}}': formatTemplateValue(templateFields.siteLeaderName || venue?.name),
    '{{messageBody.siteLeaderName}}': formatTemplateValue(
      templateFields.siteLeaderName || venue?.name
    ),
    '{{repairShopName}}': formatTemplateValue(templateFields.repairShopName),
    '{{repairShopAddress}}': formatTemplateValue(templateFields.repairShopAddress),
    '{{messageBody.repairShopAddress}}': formatTemplateValue(templateFields.repairShopAddress),
    '{{messageBody.repairShopName}}': formatTemplateValue(templateFields.repairShopName),
    '{{approvedAmount}}': formatTemplateValue(templateFields.approvedAmount),
    '{{messageBody.approvedAmount}}': formatTemplateValue(templateFields.approvedAmount),
    '{{approvedRepairs}}': formatTemplateValue(templateFields.approvedRepairs),
    '{{messageBody.approvedRepairs}}': formatTemplateValue(templateFields.approvedRepairs),
    '{{findingsSummary}}': formatTemplateValue(templateFields.findingsSummary),
    '{{messageBody.findingsSummary}}': formatTemplateValue(templateFields.findingsSummary),
    '{{denialReason}}': formatTemplateValue(templateFields.denialReason),
    '{{messageBody.denialReason}}': formatTemplateValue(templateFields.denialReason),
    '{{resolution}}': formatTemplateValue(templateFields.resolution),
    '{{messageBody.resolution}}': formatTemplateValue(templateFields.resolution),
    '{{additionalNotes}}': formatTemplateValue(templateFields.additionalNotes),
    '{{attachmentsSectionHtml}}': formatTemplateValue(templateFields.attachmentsSectionHtml),
    '{{messageBody.attachmentsSectionHtml}}': formatTemplateValue(
      templateFields.attachmentsSectionHtml
    ),
    '{{estimatesCount}}': formatTemplateValue(estimatesCount),
    '{{repairBillingName}}': formatTemplateValue(repairBillingName),
    '{{messageBody.repairBillingName}}': formatTemplateValue(repairBillingName),
    '{{messageBody.estimatesCount}}': formatTemplateValue(estimatesCount),
    '{{messageBody.additionalNotes}}': formatTemplateValue(templateFields.additionalNotes),
  };
  const safeReplacements = isHtml
    ? Object.entries(replacements).reduce(
        (nextReplacements, [token, value]) => ({
          ...nextReplacements,
          [token]: escapeHtml(value),
        }),
        {}
      )
    : replacements;

  const renderedTemplate = resolveTemplateConditionals(
    Object.entries(safeReplacements).reduce(
      (nextTemplate, [token, value]) => nextTemplate.split(token).join(value),
      template
    )
  )
    .replace(/{{#>[^}]+}}/g, '')
    .replace(/{{else}}/g, '')
    .replace(/{{\/[^}]+}}/g, '');

  if (isHtml) {
    return renderedTemplate.replace(/{{[^}]+}}/g, '').trim();
  }

  return renderedTemplate
    .replace(/{{[^}]+}}/g, '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

export const DEFAULT_EMAIL_TEMPLATE_KEY = 'EmailCustomerClaimMessage';

const getClaimEmailTemplateOrder = (template) => {
  const workflowOrder = {
    EmailClaimIncomplete: 0,
    EmailCustomerClaimMessage: 1,
    EmailClaimInvestigating: 2,
    EmailClaimResolved: 3,
    EmailClaimRepairApproval: 4,
    EmailClaimDesignatedRepairShop: 5,
    EmailClaimFinalApproval: 6,
    EmailClaimDenied: 7,
    EmailClaimCompleted: 8,
    EmailClaimClosed: 9,
  };

  return workflowOrder[getClaimEmailTemplateIdentifier(template)] ?? 10;
};

const sortClaimEmailTemplates = (templates) =>
  templates
    .map((template, index) => ({ template, index }))
    .sort(
      (left, right) =>
        getClaimEmailTemplateOrder(left.template) - getClaimEmailTemplateOrder(right.template) ||
        left.index - right.index
    )
    .map(({ template }) => template);

export const filterClaimEmailTemplates = (templates) => {
  const fetchedTemplates = Array.isArray(templates) ? templates : [];
  // Resolved claims are emailed with the Completed template, so Resolved isn't offered.
  const hiddenTemplateKeys = new Set([
    'EmailClaimIncomplete',
    'EmailClaimClosed',
    'EmailClaimResolved',
  ]);
  const validTemplates = fetchedTemplates.filter((template) => {
    const identifier = getClaimEmailTemplateIdentifier(template);
    return (
      !!(template?.key || template?.type) &&
      !!(template?.name || template?.type) &&
      !hiddenTemplateKeys.has(identifier)
    );
  });
  const fetchedTemplateKeys = new Set(
    validTemplates.map((template) => getClaimEmailTemplateIdentifier(template))
  );
  const missingRequiredTemplates = fallbackEmailTemplates.filter(
    (template) => !fetchedTemplateKeys.has(getClaimEmailTemplateIdentifier(template))
  );

  return sortClaimEmailTemplates([...validTemplates, ...missingRequiredTemplates]);
};

export const getClaimEmailTemplatesFromResponse = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.results)) return response.results;
  if (Array.isArray(response?.templates)) return response.templates;
  if (Array.isArray(response?.data?.results)) return response.data.results;
  if (Array.isArray(response?.data?.templates)) return response.data.templates;
  return [];
};

export const resolveDefaultEmailTemplateKey = (templates, currentTemplate) => {
  const nextTemplates = Array.isArray(templates) ? templates : [];
  if (
    currentTemplate &&
    nextTemplates.some((template) => getClaimEmailTemplateIdentifier(template) === currentTemplate)
  ) {
    return currentTemplate;
  }
  if (
    nextTemplates.some(
      (template) => getClaimEmailTemplateIdentifier(template) === DEFAULT_EMAIL_TEMPLATE_KEY
    )
  ) {
    return DEFAULT_EMAIL_TEMPLATE_KEY;
  }
  return getClaimEmailTemplateIdentifier(nextTemplates[0]) || '';
};

const escapeHtml = (value) =>
  `${value || ''}`
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const appendSiteSpecificInformation = (template, siteSpecificInformation) => {
  const approvedTemplate = `${template || ''}`;
  const siteText = `${siteSpecificInformation || ''}`.trim();
  if (!siteText) return approvedTemplate;

  const formattedSiteText = escapeHtml(siteText).replace(/\r?\n/g, '<br>');
  const appendedTableRow = `<tr><td class="content-block" style="padding: 20px 0 0;" valign="top"><strong>Additional information from your local site:</strong><br>${formattedSiteText}</td></tr>`;
  const appendedParagraph = `<p class="site-specific-information" style="padding: 20px 0 0;"><strong>Additional information from your local site:</strong><br>${formattedSiteText}</p>`;
  const sincerelyIndex = approvedTemplate.search(/\bSincerely\b/i);
  const signOffRowIndex =
    sincerelyIndex === -1 ? -1 : approvedTemplate.lastIndexOf('<tr', sincerelyIndex);
  const signOffParagraphIndex =
    sincerelyIndex === -1 ? -1 : approvedTemplate.lastIndexOf('<p', sincerelyIndex);

  if (signOffParagraphIndex > signOffRowIndex) {
    return `${approvedTemplate.slice(
      0,
      signOffParagraphIndex
    )}${appendedParagraph}${approvedTemplate.slice(signOffParagraphIndex)}`;
  }

  if (signOffRowIndex !== -1) {
    return `${approvedTemplate.slice(
      0,
      signOffRowIndex
    )}${appendedTableRow}${approvedTemplate.slice(signOffRowIndex)}`;
  }

  const closingTableIndex = approvedTemplate.lastIndexOf('</table>');

  if (closingTableIndex === -1) {
    return `${approvedTemplate}<div><strong>Additional information from your local site:</strong><br>${formattedSiteText}</div>`;
  }

  return `${approvedTemplate.slice(
    0,
    closingTableIndex
  )}${appendedTableRow}${approvedTemplate.slice(closingTableIndex)}`;
};

const normalizeTemplateContentItem = (item) => {
  if (typeof item === 'string') return item;
  if (item?.data === null || item?.data === undefined) return '';
  if (typeof item.data === 'string') return item.data;
  return '';
};

const buildTemplateMarkupFromSections = (templateData = {}) => {
  const sections = [];
  const contentItems = Array.isArray(templateData.content)
    ? templateData.content.map(normalizeTemplateContentItem).filter(Boolean)
    : [];

  if (templateData.title) {
    sections.push(`<h3>${escapeHtml(templateData.title)}</h3>`);
  }
  if (templateData.subtitle) {
    sections.push(`<p><strong>${escapeHtml(templateData.subtitle)}</strong></p>`);
  }
  if (templateData.message) {
    sections.push(`<p>${escapeHtml(templateData.message).replace(/\n/g, '<br />')}</p>`);
  }
  if (contentItems.length) {
    contentItems.forEach((item) => {
      sections.push(`<p>${escapeHtml(item).replace(/\n/g, '<br />')}</p>`);
    });
  }

  return sections.join('');
};

export const getRenderedEmailTemplateResponse = (
  response,
  templateKey,
  { reclamation, venue, operatorGroup, templateFields = {} } = {}
) => {
  const fallbackBody = fallbackEmailTemplateBodies[templateKey] || '';
  const rawTemplate =
    response?.template || response?.data?.template || response?.data || response || {};
  const localizedTemplate =
    (Array.isArray(rawTemplate.localizedContent) && rawTemplate.localizedContent[0]) || {};
  const mergedTemplate = {
    ...rawTemplate,
    ...localizedTemplate,
    content:
      localizedTemplate.content ||
      rawTemplate.content ||
      response?.content ||
      response?.data?.content ||
      [],
    subject:
      localizedTemplate.subject ||
      rawTemplate.subject ||
      response?.subject ||
      response?.data?.subject ||
      '',
  };
  const normalizedMarkup = buildTemplateMarkupFromSections(mergedTemplate);
  // Use the approved email copy while provider templates are being updated.
  const approvedBody = [
    DEFAULT_EMAIL_TEMPLATE_KEY,
    'EmailClaimInvestigating',
    'EmailClaimRepairApproval',
    'EmailClaimDesignatedRepairShop',
    'EmailClaimFinalApproval',
    'EmailClaimDenied',
    'EmailClaimCompleted',
  ].includes(templateKey)
    ? fallbackBody
    : '';
  const templateHtml =
    approvedBody ||
    response?.html ||
    response?.templateHtml ||
    response?.data?.html ||
    response?.data?.templateHtml ||
    response?.template?.html ||
    normalizedMarkup ||
    fallbackBody;
  const templateText =
    response?.text ||
    response?.templateText ||
    response?.data?.text ||
    response?.data?.templateText ||
    response?.template?.text ||
    mergedTemplate.message ||
    (Array.isArray(mergedTemplate.content)
      ? mergedTemplate.content.map(normalizeTemplateContentItem).filter(Boolean).join('\n\n')
      : '') ||
    fallbackBody;
  const templateSubject =
    mergedTemplate.subject || fallbackEmailTemplateSubjects[templateKey] || '';
  const renderedHtml = renderEmailTemplateBody(templateHtml, {
    isHtml: true,
    reclamation,
    venue,
    operatorGroup,
    templateFields,
  });
  const renderedText = renderEmailTemplateBody(templateText, {
    reclamation,
    venue,
    operatorGroup,
    templateFields,
  });
  const renderedSubject = renderEmailTemplateBody(templateSubject, {
    reclamation,
    venue,
    templateFields,
  });
  const nextBody = renderedHtml || renderedText;

  return {
    loadedEmailSubject: renderedSubject,
    loadedEmailHtml: nextBody,
    emailBody: nextBody,
  };
};

export const TIMELINE_LABELS = {
  note_added: 'Note added',
  status_change: 'Status updated',
  call_logged: 'Call logged',
  sms_sent: 'Text sent',
  email_sent: 'Email sent',
  followup_set: 'Follow-up set',
  not_approved_or_denied_week_alert_sent: 'Manager alerted: claim awaiting approval/denial',
  claim_email_approval_notification_created: 'Manager notified: approve and send claim email',
  claim_email_auto_sent_after_approval_timeout:
    'Claim email sent automatically after approval timeout',
  claim_created: 'Claim created',
  claim_created_notification_created: 'Claim created notification created',
  incident_occurred: 'Incident occurred',
  cost_change: 'Cost change',
  status_override: 'Status override',
};

export const formatTimelineEventLabel = (eventType) => {
  const normalized = `${eventType || ''}`
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!normalized) return 'Update';

  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};

export const formatTimelineCreator = (creator) => {
  if (creator === 'send-reclamation-not-denied-week-alerts-task') {
    return 'Manager alerted: claim awaiting approval/denial';
  }
  if (creator === 'send-reclamation-approval-timeout-emails-task') {
    return 'Automatic claim email timeout task';
  }

  return creator;
};

export const sortTimelineItems = (items) => {
  if (!Array.isArray(items)) return [];

  return [...items].sort((a, b) => {
    const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
    const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
    return bTime - aTime;
  });
};

export const filterTimelineByType = (items, eventType) => {
  if (!Array.isArray(items)) return [];
  return items.filter((item) => item.eventType === eventType);
};

export const getVisibleTimelineItems = (items, showAll, limit = 5) => {
  if (!Array.isArray(items)) return [];
  return showAll ? items : items.slice(0, limit);
};

export const getTimelineHistoryGroups = (items) => ({
  emailHistoryItems: filterTimelineByType(items, 'email_sent'),
  smsHistoryItems: filterTimelineByType(items, 'sms_sent'),
  callHistoryItems: filterTimelineByType(items, 'call_logged'),
  followUpHistoryItems: filterTimelineByType(items, 'followup_set'),
});

export const getNormalizedRecipients = (emailRecipients) =>
  (Array.isArray(emailRecipients) ? emailRecipients : []).filter(Boolean);

export const getPrimaryRecipient = (emailRecipients) => getNormalizedRecipients(emailRecipients)[0];

export const addEmailRecipient = (emailRecipients, inputValue) => {
  const trimmed = `${inputValue || ''}`.trim().replace(/,$/, '');
  if (!trimmed) {
    return {
      recipients: Array.isArray(emailRecipients) ? emailRecipients : [],
      added: false,
      nextInput: '',
    };
  }

  const currentRecipients = Array.isArray(emailRecipients) ? emailRecipients : [];
  if (currentRecipients.includes(trimmed)) {
    return {
      recipients: currentRecipients,
      added: false,
      nextInput: '',
    };
  }

  return {
    recipients: [...currentRecipients, trimmed],
    added: true,
    nextInput: '',
  };
};

export const removeEmailRecipient = (emailRecipients, email) =>
  (Array.isArray(emailRecipients) ? emailRecipients : []).filter((item) => item !== email);

export const buildOperatorGroupPayload = (operatorGroup) => {
  if (!operatorGroup) return null;
  const operatorGroupDetails = operatorGroup?.details || {};

  return {
    name: operatorGroup.name,
    details: {
      email: operatorGroupDetails.email || operatorGroup.email,
      emailSendingDomain:
        operatorGroupDetails.emailSendingDomain || operatorGroup.emailSendingDomain,
    },
  };
};

export const getVenuePayload = (venue, reclamation) => venue || reclamation?.issueSite || null;

export const getSendEmailSiteId = (reclamation) =>
  reclamation?.siteId || reclamation?.issueSiteId || reclamation?.issueSite?.id;

export const getDialNumber = (customerPhone) =>
  customerPhone ? customerPhone.replace(/[^\d+]/g, '') : null;

export const buildEmailTemplateRenderKey = (reclamation, venuePayload) =>
  [
    reclamation?.id,
    reclamation?.customerName,
    reclamation?.customerPhone,
    reclamation?.issueDate,
    reclamation?.status,
    reclamation?.issueSite?.name,
    venuePayload?.name,
    reclamation?.vehicleDetails?.make,
    reclamation?.vehicleDetails?.model,
    reclamation?.vehicleDetails?.year,
    reclamation?.vehicleDetails?.color,
    reclamation?.vehicleDetails?.vin,
    reclamation?.vehicleDetails?.plate,
  ].join('|');

export const formatCallOutcome = (outcome) =>
  `${outcome || ''}`
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getTimelineNotePreview = (note, isExpanded, max = 140) => {
  if (!note) return '';
  return isExpanded || note.length <= max ? note : `${note.slice(0, max)}...`;
};

export const shouldShowTimelineNoteToggle = (note, max = 140) => !!note && note.length > max;

export const getCostChangeTitle = (item, formatAmountValue, fallbackLabel) => {
  const costFrom =
    item?.details?.fromCost ??
    item?.details?.from ??
    item?.details?.previousCost ??
    item?.details?.oldCost ??
    null;
  const costTo =
    item?.details?.toCost ??
    item?.details?.to ??
    item?.details?.newCost ??
    item?.details?.cost ??
    null;
  const costFromLabel = formatAmountValue(costFrom);
  const costToLabel = formatAmountValue(costTo);

  if (costFromLabel && costToLabel) {
    return `Cost change: ${costFromLabel} to ${costToLabel}`;
  }

  return fallbackLabel;
};

export const refreshReclamationRecord = (getReclamation, reclamationId) => {
  if (getReclamation && reclamationId) {
    getReclamation(reclamationId);
  }
};

export const getResetEmailState = (reclamation, emailTemplates, loadedEmailHtml) => ({
  activeCustomerAction: null,
  emailRecipients: reclamation?.customerEmail ? [reclamation.customerEmail] : [],
  emailInput: '',
  emailTemplate: resolveDefaultEmailTemplateKey(emailTemplates),
  emailBody: loadedEmailHtml,
});

export const getResetCallState = () => ({
  activeCustomerAction: null,
  callNotes: '',
  callOutcome: 'connected',
});

export const getResetFollowUpState = () => ({
  activeCustomerAction: null,
  followUpDate: null,
  followUpNotes: '',
});

export const formatFollowUpHistoryLabel = (followupAt) =>
  followupAt
    ? `Follow-up Set for ${moment(followupAt).format('MMM D, YYYY h:mm A')}`
    : 'Follow-up scheduled';

export const getRecentActiveNotes = (notes, limit = 3) =>
  (Array.isArray(notes) ? notes : []).filter((note) => !note.archivedAt).slice(0, limit);

// Status names are stored as enum keys such as "RepairApproved"; formatStatusName turns them into
// the labels the status menus show.
export const getStatusChangeTitle = (details, formatStatusName = formatTimelineEventLabel) => {
  const fromStatus = details?.fromStatus ? formatStatusName(details.fromStatus) : '';
  const toStatus = details?.toStatus ? formatStatusName(details.toStatus) : '';

  if (fromStatus && toStatus) return `Status changed from ${fromStatus} to ${toStatus}`;
  if (toStatus) return `Status changed to ${toStatus}`;
  return null;
};

export const getTimelineTitle = (item, formatAmountValue, timelineLabels, formatStatusName) => {
  if (item?.eventType === 'status_change') {
    const statusChangeTitle = getStatusChangeTitle(item?.details, formatStatusName);
    if (statusChangeTitle) return statusChangeTitle;
  }

  if (item?.eventType === 'followup_set') {
    return formatFollowUpHistoryLabel(item?.details?.followupAt);
  }

  if (item?.eventType === 'cost_change') {
    return getCostChangeTitle(item, formatAmountValue, timelineLabels.cost_change);
  }

  return timelineLabels[item?.eventType] || formatTimelineEventLabel(item?.eventType);
};
